module.exports = __webpack_public_path__ + "img/nowbutton.ea185510.png";